import React from 'react'
import format from 'date-fns/format'
import { numberWithCommas } from '../../utils/utils'

export const CustomToolTip = ({
  type,
  payload,
  label,
  formatter,
  labelFormatter
}) => {
  const val = payload && payload[0] && payload[0].value

  return (
    <div className='CustomToolTip'>
      <span className='value'>
        {/* If there's a formatter, use it. Otherwise, if it's a number, format it, otherwise just spit it out */}
        {typeof formatter === 'function'
          ? formatter(val)
          : typeof val === 'number'
          ? numberWithCommas(val)
          : val}
      </span>
      <span className='title'>
        {/* If type passed is date, and there's no formatter specified, format it. Otherwise use the provided formatter or just spit out the value. */}
        {type === 'date' && typeof labelFormatter !== 'function' && label
          ? format(label, 'M/D/YYYY')
          : typeof labelFormatter === 'function'
          ? labelFormatter(label)
          : label}
      </span>
    </div>
  )
}

export default CustomToolTip
